export type CreditCardBrand =
  | "mastercard"
  | "amex"
  | "visa"
  | "discover"
  | "diners"
  | "jcb"
  | "unionpay"
  | "elo";
export interface CreditCardData {
  name: string;
  logo: JSX.Element;
}
interface PaymentMethodDetails {
  bankName?: string;
  brand?: CreditCardBrand;
  lastFour: string;
  expirationDate?: string;
  billingName?: string;
}

export interface PaymentMethod {
  isDefault: boolean;
  paymentMethodId: string;
  paymentMethodInfo: PaymentMethodDetails;
}

export enum AutoPayTypes {
  AllInvoices = "ALL_INVOICES",
  AllInvoicesUpdate = "ALL_INVOICES_UPDATE"
}

export enum SchedulePayTypes {
  IndividualInvoices = "INDIVIDUAL_INVOICES",
  IndividualInvoicesUpdate = "INDIVIDUAL_INVOICES_UPDATE",
  CheckoutSchedulePayment = "CHECKOUT_SCHEDULE_PAYMENT"
}
